import type { DocumentsResponse, DocumentToShow } from '@/types/document';

type GetGreaseTrapDocumentsQuery = {
  getGreaseTrapDocuments?: DocumentsResponse;
};

export function mapGreaseTrapDocumentsResponse(
  fetchData?: GetGreaseTrapDocumentsQuery,
): { data: DocumentToShow[]; count: number } {
  const documents = fetchData?.getGreaseTrapDocuments?.data ?? [];

  return {
    data: documents.map((document) => ({
      id: document.id,
      name: document.name || '',
      type: document.type || '',
      date: document.date || '',
      url: document.url || '',
    })),
    count: fetchData?.getGreaseTrapDocuments?.count ?? 0,
  };
}
